import React, { Component } from 'react';
import '../styles/Footer.css';
import { Link } from 'react-router-dom';

export class FooterComponent extends Component {
    displayName = FooterComponent.name

    constructor(props) {
        super(props);
        this.handleSelect = this.handleSelect.bind(this);

    }

    handleSelect() {
        window.scrollTo(0, 0);
    }


    render() {
        return (

            <footer>
                <section id="footer">
                    <div className="col-12" style={{ backgroundColor: '#757575' }}>
                        <div className="row" style={{ marginLeft: '0px' }}>
                            <div className="col">
                                <div class="footer_headings">About</div>
                                <ul className="list-unstyled quick-links">
                                    <li className="paddingset"><a href="https://wolterskluwer.com/" target="_blank">Our company</a></li>
                                    <li className="paddingset"><a href="http://authors.wolterskluwerblogs.com/" target="_blank">Our authors</a></li>
                                    <li className="paddingset">
                                        <Link onClick={this.handleSelect} to={{ pathname: '/StaticContent/OurContent', state: { page: 'OurContent' } }}>Our content</Link>
                                        
                                    </li>
                                    <li className="paddingset">
                                        <Link onClick={this.handleSelect} to={{ pathname: '/StaticContent/AdvisoryBoard', state: { page: 'AdvisoryBoard' } }} >Our ethics statement</Link>
                                        
                                    </li>
                                </ul>

                            </div>
                            <div className="col">
                                <div class="footer_headings">Kluwer books</div>                                
                                <ul className="list-unstyled quick-links">
                                    <li className="paddingset"><a href="https://law-store.wolterskluwer.com/" target="_blank">E-store</a></li>
                                    <li className="paddingset">
                                        <a href="https://wkldigitalbooks.integra.co.in/Customer/Home" target="_blank">Digital Book Platform</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col">
                                <div class="footer_headings">Other research sites</div>                                                                
                                <ul className="list-unstyled quick-links">
                                    <li className="paddingset"><a href="http://www.kluwerarbitration.com/" target="_blank">Kluwer Arbitration</a></li>
                                    <li className="paddingset"><a href="http://www.kluweriplaw.com" target="_blank">Kluwer IP Law</a></li>
                                    <li className="paddingset"><a href="http://www.kluwercompetitionlaw.com" target="_blank">Kluwer Competition Law</a></li>
                                    <li className="paddingset"><a href="http://www.kluwertaxlaw.com" target="_blank">Kluwer International Tax Law</a></li>
                                    <li className="paddingset"><a href="http://www.kluwerlaw.com/peplus" target="_blank">Kluwer PE+</a></li>
                                </ul>

                            </div>
                            <div className="col">
                                <div class="footer_headings">Contact</div>                                                                                                
                                <ul className="list-unstyled quick-links">
                                    <li className="paddingset"><Link to="/ContactSales" onClick={this.handleSelect}>Sales</Link></li>
                                    <li className="paddingset"><a href="https://www.wolterskluwer.com/en/solutions/kluwerlawinternational/authors" target="_blank">For Authors</a></li>
                                    <li className="paddingset"><Link to="/Feedback" onClick={this.handleSelect}>Customer support & feedback</Link></li>
                                </ul>
                            </div>
                            <div className="col">
                                <div class="footer_headings">Follow us</div>                                 
                                <ul className="list-unstyled list-inline social" style={{ paddingTop: '4px 0', paddingLeft: '9px' }}>
                                    <li className="list-inline-item" style={{ marginRight: '8%' }}><a href="https://www.facebook.com/wolterskluwer" target="_blank" title="Follow us on Facebook"><i className="fa fa-facebook"><span class="sr-only sr-only-focusable">Follow us on Facebook</span></i></a></li>
                                    <li className="list-inline-item" style={{ marginRight: '8%' }}><a href="https://X.com/kluwerlawint" target="_blank" title="Follow us on X"><h4>𝕏<span class="sr-only sr-only-focusable">Follow us on X</span></h4></a></li>
                                    <li className="list-inline-item" style={{ marginRight: '8%' }}><a href="https://www.linkedin.com/company/kluwer-law-international/" target="_blank" title="Follow us on Linkedin"><i className="fa fa-linkedin"><span class="sr-only sr-only-focusable">Follow us on Linkedin</span></i></a></li>
                                    <li className="list-inline-item" style={{ marginRight: '8%' }}><a href="https://www.youtube.com/channel/UCQ7QGjmuPSfyqqNs-Y01ejw" target="_blank" title="Follow us on Youtube"><i className="fa fa-youtube"><span class="sr-only sr-only-focusable">Follow us on Linkedin</span></i></a></li>
                                   
                                </ul>

                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <img src="/../../images/white-small.svg" alt="Wolters Kluwer Logo" style={{color: 'white',paddingLeft: '20px'}} />
                            </div>

                            <div className="col">
                                <span className="TagLine" style={{ float: 'right' }}> When you have to be right </span>
                            </div>
                        </div>
                    </div>

                    <br></br>
                    <div className="reserved-bot row">
                        <div className="col-lg-6">
                            <p className="text-center text-md-left Bgrey" style={{ marginLeft: '3%',fontSize:'15px'}}>
                                © {new Date().getFullYear()} Kluwer Law International BV, and/or its subsidiaries, licensors, and contributors. All rights reserved, including rights for text and data mining, AI training, and similar technologies.
                           </p>
                        </div>

                        <div className="col-lg-6">
                            <ul className="list-unstyled list-inline" style={{ textAlign: 'center' }}>
                                    <li className="list-inline-item">
                                    <a href="https://www.kluwerlawonline.com/AccessibilityKLO" target="_blank" className="FooterDisclaimer">Accessibility Statement</a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a href="http://www.kluwerlaw.com/disclaimer/" target="_blank" className="FooterDisclaimer">Disclaimer</a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a href="http://www.kluwerlaw.com/privacy-policy/" target="_blank" className="FooterDisclaimer">Privacy and Cookie Statement</a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a href="http://www.kluwerlaw.com/rights-and-permissions/" target="_blank" className="FooterDisclaimer">Rights & Permissions</a>
                                    </li>
  <li className="list-inline-item">
                                        <a href="http://www.kluwerlaw.com/terms-and-conditions/" target="_blank" className="FooterDisclaimer">Terms and Conditions</a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a href="http://www.kluwerlaw.com/gdpr/" target="_blank" className="FooterDisclaimer">GDPR</a>
                                    </li>
                                </ul>
                        </div>

                    </div>

                </section>


            </footer>



        );
    }
}



// WEBPACK FOOTER //
// ./src/components/FooterComponent.jsx